import { useContext } from 'react';

import { HStack, Text, VStack, Flex } from '@chakra-ui/react';

import style from './DashboardJourneyProgress.style';
import { TProjectCompletionRes } from './DashboardJourneyProgress.types';

import { CircularProgress } from '@/components';
import useTranslate from '@/hooks/useTranslate';
import { DashboardContext } from '@/providers/DashboardContext';

interface JourneyProgress {
  isHomePage?: boolean;
  isDMTMobile?: boolean;
  isDMTSmallDevice?: boolean;
  data?: TProjectCompletionRes;
  isLoading?: boolean;
}

const DashboardJourneyProgress = ({
  isHomePage = false,
  isDMTMobile = false,
}: JourneyProgress) => {
  const { t } = useTranslate();
  const { journeyProgressData: data, journeyProgressLoading: isLoading } =
    useContext(DashboardContext);

  return (
    <HStack
      sx={
        isHomePage && isDMTMobile
          ? style.homePageDMTMobileRoot
          : isHomePage && !isDMTMobile
            ? style.homePageRoot
            : style.root
      }
    >
      <VStack sx={style.textWrapper}>
        <Flex>
          <Text
            sx={{ ...style.title, color: isDMTMobile ? 'white' : 'black' }}
            whiteSpace="pre-line"
          >
            {t('portal_journey_completion').replace(/ (\S+)$/, '\n$1')}
          </Text>
        </Flex>
      </VStack>
      <VStack>
        <CircularProgress
          isIndeterminate={isLoading}
          value={data ?? 0}
          color={isDMTMobile ? 'white' : 'black'}
        />
      </VStack>
    </HStack>
  );
};

export default DashboardJourneyProgress;
